module.exports = __webpack_public_path__ + "media/images/keywords-8cf70f825da55f7043b26ff91f599a06.svg";